import getFirebaseInstance from "./firebase";
import useAuth from './useAuth';
import FirebaseContext from "./context";

export { FirebaseContext, useAuth };
export default getFirebaseInstance;